import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useTexture } from '@react-three/drei';
import { SRGBColorSpace } from 'three';
import { Atmosphere } from './Atmosphere.jsx';
import { useCelestial } from './CelestialProvider.jsx';

// Textured planet: real equirectangular map + fresnel atmosphere shell.
// Lighting (day/night terminator) comes from the scene's directional light.
export function Planet({
  map,
  radius = 1,
  position = [0, 0, 0],
  scale = 1,
  spin = 0.05,
  axialTilt = 0.1,
  atmosphereColor = '#7fa8dd',
  atmosphereIntensity = 0.6,
  children,
}) {
  const ref = useRef();
  const { perfTier } = useCelestial();
  const texture = useTexture(map, (t) => {
    t.colorSpace = SRGBColorSpace;
    t.anisotropy = 4;
  });

  useFrame((state) => {
    if (!ref.current) return;
    ref.current.rotation.y = state.clock.elapsedTime * spin;
  });

  return (
    <group position={position} scale={scale} rotation={[axialTilt, 0, axialTilt * 0.6]}>
      <mesh ref={ref}>
        <sphereGeometry args={[radius, perfTier.planetSegments, perfTier.planetSegments / 2]} />
        <meshStandardMaterial map={texture} roughness={1} metalness={0} />
      </mesh>
      <Atmosphere radius={radius} color={atmosphereColor} intensity={atmosphereIntensity} />
      {children}
    </group>
  );
}
